<div *ngIf="(progressStepperConfig$ | async) && processService.isNavigation" class="progress-stepper">
  <qbe-progress-stepper
    [hideLeftArrowIcon]='!(hideLeftArrowIcon$ | async) || false'
    [stepperConfig]='(progressStepperConfig$ | async)!'
    (goBackClick)='goToPreviousStep()'
    (stepClick)='goToStep($event)'
  ></qbe-progress-stepper>
</div>
